import React from "react";
import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { WA_CTA } from "../lib/site";

const CTA = () => (
  <section data-testid="cta-section" className="relative overflow-hidden py-28 lg:py-36">
    <div className="pointer-events-none absolute left-1/2 top-1/2 h-[30rem] w-[54rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-r from-[#00E5FF]/12 to-[#8A2BE2]/15 blur-[130px]" />
    <div className="bg-grid absolute inset-0 opacity-50 [mask-image:radial-gradient(ellipse_at_center,black_25%,transparent_70%)]" />
    <div className="relative mx-auto max-w-4xl px-6 text-center lg:px-10">
      <Reveal>
        <h2 className="font-display text-3xl font-extrabold leading-[1.12] tracking-tight sm:text-5xl lg:text-6xl">
          SUA IDEIA PODE SE TRANSFORMAR EM UMA{" "}
          <span className="text-gradient">SOLUÇÃO DIGITAL.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <p className="mx-auto mt-7 max-w-xl text-base font-light leading-relaxed text-white/70 md:text-lg">
          Conte para a EDALIX o que sua empresa precisa. Vamos transformar sua
          necessidade em tecnologia.
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-11 flex flex-col items-center gap-4">
          <a
            href={WA_CTA}
            target="_blank"
            rel="noreferrer"
            data-testid="cta-whatsapp-button"
            className="inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-[#00E5FF] to-[#8A2BE2] px-9 py-4.5 text-base font-semibold text-white shadow-[0_18px_55px_-14px_rgba(0,229,255,0.6)] transition-[transform,filter] duration-300 hover:scale-[1.04] hover:brightness-110"
            style={{ paddingTop: "1.1rem", paddingBottom: "1.1rem" }}
          >
            <MessageCircle className="h-5 w-5" />
            Falar com a EDALIX
          </a>
          <span className="text-xs font-light tracking-wide text-white/40">
            Atendimento rápido pelo WhatsApp
          </span>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTA;
